import { createPublicClient, type PublicClient } from 'viem';
import { baseChainWithFallbackTransport, createBaseFallbackTransport } from './baseRpc';

let singleton: PublicClient | null = null;

export function getBasePublicClient(): PublicClient {
  if (!singleton) {
    // Cast: viem widens the client type with the Base chain's OP-stack
    // formatters, which is not assignable to the bare `PublicClient` alias.
    singleton = createPublicClient({
      chain: baseChainWithFallbackTransport,
      transport: createBaseFallbackTransport(),
    }) as PublicClient;
  }
  return singleton;
}

/** Prefer wagmi's client when present; otherwise Base singleton (never skip on-chain reads). */
export function getPublicClientForReads(wagmiClient: PublicClient | undefined): PublicClient {
  return wagmiClient ?? getBasePublicClient();
}
